

import { useState, useEffect } from "react";
import "./CompaniesCard.css";

const companyData = [
  { src: "/assets/BabyDay.jpg", alt: "playground equipment manufacturers", line: 1 },
  { src: "/assets/CandyKids.jpg", alt: "playTurn on screen reader supportground equipment catalog", line: 1 },
  { src: "/assets/Cheese.jpg", alt: "playground equipment suppliers", line: 1 },
  { src: "/assets/HappyTimes.jpg", alt: "commercial indoor playground equipment", line: 1 },
  { src: "/assets/KidsZone.jpg", alt: "playgrounds", line: 1 },
  { src: "/assets/XVilliage.jpg", alt: "indoor commercial playground", line: 1 },
  { src: "/assets/Spinners.jpg", alt: "highest quality trampoline", line: 2 },
  { src: "/assets/new/little conders.png", alt: "highest quality trampoline", line: 2 },
  { src: "/assets/new/park.png", alt: "highest quality trampoline", line: 2 },
  { src: "/assets/new/peekaboo.png", alt: "highest quality trampoline", line: 2 },
  { src: "/assets/new/tafilah park.png", alt: "highest quality trampoline", line: 2 },
  { src: "/assets/new/wonderland.png", alt: "highest quality trampoline", line: 2 },
];

export default function CompanyCards() {
  const [activeLine, setActiveLine] = useState(1);

  useEffect(() => {
    setActiveLine(1);
  }, []);

  return (
    <div className="company-container">
      <h2 className="company-title">Companies We Worked With</h2>
      <div className="carousel-container">
        <div className="carousel">
          {companyData.map((company, index) => (
            <img
              key={index}
              src={company.src}
              alt={company.alt}
              className={`company-image ${activeLine === company.line ? "visible" : "hidden"}`}
            />
            
          ))}
        </div>
      </div>
      <div className="toggle-buttons">
        <div className={`line ${activeLine === 1 ? "active" : ""}`} onClick={() => setActiveLine(1)}></div>
        <div className={`line ${activeLine === 2 ? "active" : ""}`} onClick={() => setActiveLine(2)}></div>
      </div>
    </div>
  );
}

